import { NavLink } from "react-router-dom";
import {
  Activity,
  BarChart3,
  Building2,
  CreditCard,
  FileText,
  Gauge,
  Users,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { isBillingEnabled } from "@/lib/runtime-env";

interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  end?: boolean;
}

// Section 1: Plataforma
const plataforma: NavItem[] = [
  { to: "/", label: "Dashboard", icon: Gauge, end: true },
  { to: "/teams", label: "Equipos", icon: Users },
  { to: "/companies", label: "Empresas", icon: Building2 },
];

// Section 2: Operaciones
const operaciones: NavItem[] = [
  { to: "/health", label: "Salud API", icon: Activity },
  { to: "/dian-processes", label: "Procesos DIAN", icon: FileText },
  { to: "/subscriptions", label: "Suscripciones", icon: CreditCard },
];

function Item({ to, label, icon: Icon, end }: NavItem) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          "flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors",
          isActive
            ? "bg-brand-50 text-brand-700 font-medium"
            : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
        )
      }
    >
      <Icon className="h-4 w-4" />
      {label}
    </NavLink>
  );
}

export function Sidebar() {
  return (
    <aside className="w-56 shrink-0 border-r border-slate-200 bg-white px-3 py-4 flex flex-col gap-6">
      <div>
        <p className="px-3 pb-2 text-[10px] font-semibold text-slate-400 uppercase tracking-wider">
          Plataforma
        </p>
        <nav className="space-y-0.5">
          {plataforma.map((item) => (
            <Item key={item.to} {...item} />
          ))}
        </nav>
      </div>
      <div>
        <p className="px-3 pb-2 text-[10px] font-semibold text-slate-400 uppercase tracking-wider">
          Operaciones
        </p>
        <nav className="space-y-0.5">
          {operaciones
            .filter((item) => isBillingEnabled() || item.to !== "/subscriptions")
            .map((item) => (
            <Item key={item.to} {...item} />
          ))}
        </nav>
      </div>
      <div className="mt-auto px-3 text-[11px] text-slate-400">
        <p className="flex items-center gap-1">
          <BarChart3 className="h-3 w-3" />
          API base
        </p>
        <p className="font-mono break-all text-slate-500">
          {import.meta.env.VITE_API_BASE_URL ??
            (import.meta.env.DEV
              ? "http://localhost:8580"
              : "https://api.pahfacturar.com")}
        </p>
      </div>
    </aside>
  );
}
